import { queryKeys } from '../queryKeys';

import { fetchLastWatched } from './queryFunctions';

export function createLastWatchedQueryOptions() {
  return {
    queryKey: queryKeys.lastWatched,
    queryFn: () => fetchLastWatched(),
    staleTime: Infinity,
  };
}
